import get from 'lodash.get';

const getComputedStyleForNode = (node, styleName) =>
  get(node.ownerDocument.defaultView.getComputedStyle(node), styleName, 'none');

export default getComputedStyleForNode;
